import { render, staticRenderFns } from "./actionModal.vue?vue&type=template&id=b6c9cbba&scoped=true&"
import script from "./actionModal.vue?vue&type=script&lang=js&"
export * from "./actionModal.vue?vue&type=script&lang=js&"
import style0 from "./actionModal.vue?vue&type=style&index=0&id=b6c9cbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c9cbba",
  null
  
)

export default component.exports